import Immutable from 'immutable';
import { useMemo } from 'react';

import { toJsIfImmutable } from '@alkem/micro-frontend-tools';
import { Select } from '@alkem/react-ui-select';

import AuthFormSelectWrapper from './select-wrapper';

export default function AuthFormSelect({
  formKey,
  onChange,
  value,
  error,
  errorMessage,
  options,
}: {
  formKey: string;
  onChange: Function;
  value?: Immutable.Map<string, any> | object;
  error?: boolean | Immutable.List<any>;
  errorMessage?: string;
  options?: Immutable.List<any> | any[];
}) {
  const formattedValue = useMemo(
    () => (value ? [toJsIfImmutable(value)] : []),
    [value],
  );

  const formattedOptions = useMemo(
    () => options && toJsIfImmutable(options),
    [options],
  );

  return (
    <AuthFormSelectWrapper error={error} errorMessage={errorMessage}>
      <Select
        id={`auth-form-select-${formKey}`}
        onValueAdd={({ label, id }) => {
          onChange({ formKey, value: Immutable.Map({ label, id }) });
        }}
        onValueDelete={() => {
          onChange({ formKey });
        }}
        values={formattedValue}
        options={formattedOptions}
        placeholder=""
        inputable
      />
    </AuthFormSelectWrapper>
  );
}
